var map = {
	"./datasets/common/font-theatre-black-6x10.json": [
		158,
		1
	],
	"./datasets/common/font-theatre-mask-black-6x10.json": [
		159,
		2
	],
	"./datasets/common/font-theatre-mask-white-6x10.json": [
		160,
		3
	],
	"./datasets/common/font-theatre-red-6x10.json": [
		161,
		4
	],
	"./datasets/common/font-theatre-white-6x10.json": [
		162,
		5
	],
	"./datasets/common/font-theatre-white-shadow-black-6x10.json": [
		163,
		6
	],
	"./datasets/common/force-placeholder.json": [
		164,
		7
	],
	"./datasets/common/spritesheet-grid-idle.json": [
		165,
		8
	],
	"./datasets/common/spritesheet-placeholder-idle.json": [
		166,
		9
	],
	"./datasets/debug/inputs.json": [
		167,
		10
	],
	"./datasets/demo/force-character.json": [
		168,
		11
	],
	"./datasets/demo/force-gravity.json": [
		169,
		12
	],
	"./datasets/demo/inputs.json": [
		170,
		13
	],
	"./datasets/demo/spritesheet-00-splash.json": [
		171,
		14
	],
	"./datasets/demo/spritesheet-01-chalet-backlight.json": [
		172,
		15
	],
	"./datasets/demo/spritesheet-01-chalet-frontlight.json": [
		173,
		16
	],
	"./datasets/demo/spritesheet-01-chalet-ground.json": [
		174,
		17
	],
	"./datasets/demo/spritesheet-02-forest-backlight.json": [
		175,
		18
	],
	"./datasets/demo/spritesheet-02-forest-frontlight.json": [
		176,
		19
	],
	"./datasets/demo/spritesheet-02-forest-ground.json": [
		177,
		20
	],
	"./datasets/demo/spritesheet-03-cliff-frontlight.json": [
		178,
		21
	],
	"./datasets/demo/spritesheet-03-cliff-ground.json": [
		179,
		22
	],
	"./datasets/demo/spritesheet-04-forest-backlight.json": [
		180,
		23
	],
	"./datasets/demo/spritesheet-04-forest-ground.json": [
		181,
		24
	],
	"./datasets/demo/spritesheet-05-hospital-ground.json": [
		182,
		25
	],
	"./datasets/demo/spritesheet-character-idle.json": [
		183,
		26
	],
	"./datasets/demo/spritesheet-character-run.json": [
		184,
		27
	],
	"./datasets/demo/spritesheet-character-sad.json": [
		185,
		28
	],
	"./datasets/splash/inputs.json": [
		186,
		29
	],
	"./images/common/font-theatre-black-6x10.png": [
		187,
		30
	],
	"./images/common/font-theatre-mask-black-6x10.png": [
		188,
		31
	],
	"./images/common/font-theatre-mask-white-6x10.png": [
		189,
		32
	],
	"./images/common/font-theatre-red-6x10.png": [
		190,
		33
	],
	"./images/common/font-theatre-white-6x10.png": [
		191,
		34
	],
	"./images/common/font-theatre-white-shadow-black-6x10.png": [
		192,
		35
	],
	"./images/common/grid-640x640.png": [
		193,
		36
	],
	"./images/common/placeholder-8x1.png": [
		194,
		37
	],
	"./images/demo/00-splash-480x320.png": [
		195,
		38
	],
	"./images/demo/01-chalet-backlight-480x320.png": [
		196,
		39
	],
	"./images/demo/01-chalet-frontlight-480x320.png": [
		197,
		40
	],
	"./images/demo/01-chalet-ground-480x320.png": [
		198,
		41
	],
	"./images/demo/02-forest-backlight-480x320.png": [
		199,
		42
	],
	"./images/demo/02-forest-frontlight-480x320.png": [
		200,
		43
	],
	"./images/demo/02-forest-ground-480x320.png": [
		201,
		44
	],
	"./images/demo/03-cliff-640x320.png": [
		202,
		45
	],
	"./images/demo/03-cliff-frontlight-480x640.png": [
		203,
		46
	],
	"./images/demo/03-cliff-frontlight-640x320.png": [
		204,
		47
	],
	"./images/demo/03-cliff-ground-480x640.png": [
		205,
		48
	],
	"./images/demo/04-forest-backlight-480x320.png": [
		206,
		49
	],
	"./images/demo/04-forest-ground-480x320.png": [
		207,
		50
	],
	"./images/demo/05-hospital-ground-480x320-sheet.png": [
		208,
		51
	],
	"./images/demo/05-hospital-ground-480x320.png": [
		209,
		52
	],
	"./images/demo/character-idle-32x64.png": [
		210,
		53
	],
	"./images/demo/character-run-64x64.png": [
		211,
		54
	],
	"./images/demo/character-sad-64x64.png": [
		212,
		55
	],
	"./sounds/demo/background.mp3": [
		213,
		56
	],
	"./sounds/demo/breathe.mp3": [
		214,
		57
	],
	"./sounds/demo/cliff.mp3": [
		215,
		58
	],
	"./sounds/demo/fall.mp3": [
		216,
		59
	],
	"./sounds/demo/run.mp3": [
		217,
		60
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 37;
module.exports = webpackAsyncContext;